var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "text-white border-b-3 border-white p-_5 cursor-pointer transition-250 transition-all text-2xl md_text-base hover_text-gray-300 hover_border-gray-300 active_border-gray-300 visited_border-white",
      attrs: { tabindex: "0" },
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        },
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.$emit("click", $event)
        }
      }
    },
    [_vm._v(_vm._s(_vm.text))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }